import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { deleteVehiclesFailed, deleteVehiclesSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* deleteVehicles(action) {
  try {
    if (!action.payload) {
      throw new Error('ID not found');
    }
    const url = `${BACKEND_URL}/vehicles/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'DELETE', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(deleteVehiclesSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      yield put(deleteVehiclesFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(deleteVehiclesFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
